// This file allows the jwtInterceptor to itself by intercepted and mocked in ViTest
import jwtInterceptor from '@/common/jwt-interceptor'
export default jwtInterceptor
